import { AppHeader } from '@web_opxp/components';
import { useTranslation } from '@web_opxp/language';
import * as React from 'react';
import { useLocation } from 'react-router';
import { AssetsBaseUrl } from '../../base/env';
import { EBlogUrls, getWelcomeLink } from '../../base/utils';
import { isPostRegPage } from '../../routes';
import getMenu from './menu';

export interface IHeaderViewProps {
  focused?: boolean;
  session?: string;
  blogUrl?: EBlogUrls;
  accountAction?: () => void;
}

export const HeaderWrapper: React.FC<IHeaderViewProps> = ({ focused, session, blogUrl, accountAction }) => {
  const { language, t } = useTranslation();
  const location = useLocation();
  const pathClass = location.pathname.replace(/^\//, '').split('/')[0];
  const accountTitle = session ? t('common.common:Header.Menu.Logout') : t('common.common:Header.Menu.Login');
  const isPostReg = isPostRegPage(location.pathname);
  if (!language) {
    return null;
  }
  const navMenu = getMenu(language, location.search, accountTitle, accountAction, undefined, session, blogUrl);
  const logoLink = focused ? undefined : getWelcomeLink();

  return (
    <AppHeader
      logoLabel={t('common.common:Header.Logo') ?? ''}
      logoLink={logoLink}
      logoSrc={`${AssetsBaseUrl}/logo.svg`}
      menuItems={navMenu}
      showMenu={!isPostReg && !focused}
      className={pathClass}
    />
  );
};

export default HeaderWrapper;
